// 商品替换映射关系
// key : value   旧商品id : 新商品id
export default {
	22542: '45567',
	25917: '16842',
    72153: '58665'
};
